export default function FolderLineIcon(
  props: Pick<
    React.SVGProps<SVGSVGElement>,
    "className" | "fill" | "fillOpacity"
  >,
) {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.83464 2C5.91416 2 5.16797 2.74619 5.16797 3.66667C5.16797 4.03486 5.46645 4.33333 5.83464 4.33333C6.20283 4.33333 6.5013 4.03486 6.5013 3.66667C6.5013 3.48257 6.65054 3.33333 6.83464 3.33333H9.79051L10.4021 4.35266C10.6431 4.75427 11.0771 5 11.5454 5H13.8346C14.2028 5 14.5013 5.29848 14.5013 5.66667V8.66667C14.5013 9.03486 14.2028 9.33333 13.8346 9.33333C13.4664 9.33333 13.168 9.63181 13.168 10C13.168 10.3682 13.4664 10.6667 13.8346 10.6667C14.9392 10.6667 15.8346 9.77124 15.8346 8.66667V5.66667C15.8346 4.5621 14.9392 3.66667 13.8346 3.66667H11.5454L10.9338 2.64734C10.6929 2.24573 10.2589 2 9.79051 2H6.83464ZM2.5013 7.33333C2.5013 6.96514 2.79978 6.66667 3.16797 6.66667H5.79051L6.4021 7.68599C6.64307 8.0876 7.07708 8.33333 7.54543 8.33333H9.83463C10.2028 8.33333 10.5013 8.63181 10.5013 9V12C10.5013 12.3682 10.2028 12.6667 9.83463 12.6667H3.16797C2.79978 12.6667 2.5013 12.3682 2.5013 12V7.33333ZM3.16797 5.33333C2.0634 5.33333 1.16797 6.22876 1.16797 7.33333V12C1.16797 13.1046 2.0634 14 3.16797 14H9.83463C10.9392 14 11.8346 13.1046 11.8346 12V9C11.8346 7.89543 10.9392 7 9.83463 7H7.54543L6.93383 5.98067C6.69287 5.57907 6.25886 5.33333 5.79051 5.33333H3.16797Z"
        fill={props.fill || "white"}
      />
    </svg>
  );
}
